/**
 * Returns the appropriate display name for a customer:
 * - Business customers: businessName
 * - Individual customers: firstName + lastName
 */
export function getCustomerDisplayName(
  customer: {
    customerType?: 'individual' | 'business' | null;
    businessName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  }
): string {
  if (customer.customerType === 'business' && customer.businessName) {
    return customer.businessName;
  }
  return `${customer.firstName ?? ''} ${customer.lastName ?? ''}`.trim();
}
